var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleappleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0785 12.5547C15.1004 10.8527 16.0144 9.24221 17.4645 8.35074C16.5497 7.04429 15.0175 6.21597 13.4234 6.16609C11.7232 5.98763 10.0749 7.18348 9.2085 7.18348C8.32533 7.18348 6.99136 6.18381 5.55489 6.21337C3.68253 6.27386 1.93701 7.33838 1.02606 8.97533C-0.932111 12.3656 0.528511 17.3482 2.40428 20.0886C3.34276 21.4305 4.43959 22.9295 5.87475 22.8763C7.27915 22.8181 7.80367 21.9808 9.4989 21.9808C11.1784 21.9808 11.6705 22.8763 13.1348 22.8425C14.6418 22.8181 15.5912 21.4947 16.4968 20.14C17.1711 19.1839 17.69 18.1271 18.0342 17.0089C16.2632 16.2598 15.0805 14.4776 15.0785 12.5547Z",
    fill: "#9F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3127 4.36384C13.1343 3.37746 13.5391 2.10963 13.4411 0.82959C12.1858 0.961438 11.0262 1.5614 10.1934 2.50994C9.3791 3.43672 8.95531 4.68224 9.03543 5.91335C10.2912 5.92628 11.5257 5.34258 12.3127 4.36384Z",
    fill: "#9F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleappleicon);
export default __webpack_public_path__ + "static/media/purpleappleicon.41f4844458aeedee6d8aab3d94a6e8db.svg";
export { ForwardRef as ReactComponent };